import { render } from "./ShoppingBag.vue?vue&type=template&id=3efe99b6&scoped=true"
import script from "./ShoppingBag.vue?vue&type=script&lang=js"
export * from "./ShoppingBag.vue?vue&type=script&lang=js"

import "./ShoppingBag.vue?vue&type=style&index=0&id=3efe99b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efe99b6"]])

export default __exports__